import { HttpClient, jsonFetcher } from '@flippingbook/web.utils/dist/webservice';
import type { IHttpClient } from '@flippingbook/web.utils/dist/webservice';

export const httpClient: IHttpClient = new HttpClient({
    fetcher: jsonFetcher(window.fetch),
});
